import { defineStore } from 'pinia'
import router from '@/router'
import { cloneDeep } from 'lodash-es'
import { setParamsValue } from '@jetlinks-web/hooks'
import { onlyMessage } from '@jetlinks-web/utils'
import { handleMenus, handleMenusMap, handleSiderMenu } from '@/utils'
import { getOwnMenuThree } from '@/api/system/menu'
import { getGlobModules } from '@/router/globModules'
import { getExtraRouters } from '@/router/extraMenu'
import { USER_CENTER_ROUTE, INIT_HOME, EDGE_TOKEN_ROUTE, DASHBOARD_ROUTE,SITE_ROUTE } from '@/router/basic'
import { useAuthStore } from '@/store/auth'
import { OWNER_KEY } from "@/utils/consts";
import i18n from "@/locales";
import { useUserStore } from "@/store/user";

const $t = i18n.global.t

const defaultOwnParams = [
    {
        terms: [
            {
                terms: [
                    {
                        column: 'owner',
                        termType: 'eq',
                        value: OWNER_KEY,
                    },
                    {
                        column: 'owner',
                        termType: 'isnull',
                        value: '1',
                        type: 'or',
                    },
                ],
            },
            {
                terms: [
                    {
                        value: "%show\":false%",
                        termType: "nlike",
                        column: "options"
                    }
                ],
                type: 'and'
            }
        ],
    },
]

export const useMenuStore = defineStore('menu', () => {
    const menu = ref<any[]>([])
    const menusMap = ref<Map<string, any>>(new Map())
    const siderMenus = ref([])

    const authStore = useAuthStore()
    const userInfoStore = useUserStore();

    const hasRouteMenu = () => {
        return !!Object.keys(menu).length
    }

    const hasMenu = (code: string) => {
        return menusMap.value.has(code)
    }

    /**
     * 页面跳转
     * @param name 路由name
     * @param param1 {Object} 需要传递的参数
     */
    const jumpPage = (
        name: string,
        {
            params,
            query,
        }: {
            params?: Record<string, any>
            query?: Record<string, any>
        },
    ) => {
        if (hasMenu(name)) {
            router.push({ name, params, query })
            setParamsValue(name, params)
        } else {
            onlyMessage($t('Home.index.010851-10'), 'warning')
            console.warn(`没有找到对应的页面: ${name}`)
        }
    }
    const routerPush = (
        name: string,
        {
            params,
            query,
        }: {
            params?: Record<string, any>
            query?: Record<string, any>
        },
    ) => {
        router.push({
            name,
            params,
            query,
            state: { params },
        })
        setParamsValue(name, params)
    }
    const handleMenusMapById = (item: { name: string; path: string, meta: any }) => {
        const { name, path, meta } = item
        menusMap.value.set(name, { path, title: meta?.title })
    }

    const queryMenus = async () => {
        const resp = await getOwnMenuThree({
            paging: false,
            terms: defaultOwnParams,
        })
        const asyncRoutes = getGlobModules()
        menusMap.value.clear()

        if (resp.success) {
            const extraMenu = getExtraRouters()
            const _routes = handleMenus(cloneDeep(resp.result), extraMenu, asyncRoutes) // 处理路由
            const routes = [..._routes, USER_CENTER_ROUTE, EDGE_TOKEN_ROUTE, DASHBOARD_ROUTE,SITE_ROUTE];
            // routes.push(USER_CENTER_ROUTE) // 添加个人中心
            // routes.push(EDGE_TOKEN_ROUTE) //添加边缘网关token失效页面
            // if (_routes.length) {
            routes.push({
                path: '/',
                redirect: routes[0].path,
            })
            // }
            if (userInfoStore.userInfo?.username === 'admin') {
                routes.push(INIT_HOME) // 添加初始化页面
            }
            authStore.handlePermission(resp.result) // 处理按钮权限
            menu.value = routes
            handleMenusMap(routes, handleMenusMapById)
            siderMenus.value = handleSiderMenu(cloneDeep(resp.result)) // 处理菜单
        }
    }

    const getMenu = (name: string) => {
        return menusMap.value.get(name)
    }

    return {
        menu,
        siderMenus,
        menusMap,
        hasRouteMenu,
        hasMenu,
        jumpPage,
        routerPush,
        queryMenus,
        getMenu,
    }
})
